import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { ATRIBUI_PAINEIS_USUARIO_INIT, DESATRIBUI_PAINEIS_USUARIO_INIT } from '../actionTypes';
import { atribuiPaineisUsuarioSuccess, desatribuiPaineisUsuarioSuccess, painelUserErrorMsg } from './actions';
import { atribuiPaineisUsuario, desatribuirPaineisUsuario } from 'src/integracoes/servicos/mongo-atlas/funcoes/usuarios';

// ------------------------Atribuir Painéis ao usuario -------------------------------

const fetchAtribuiPaineisUsuario = async (userId: string, payload: any) => {
  try {
    const { status, mensagem } = await atribuiPaineisUsuario(userId, payload);
    if (status) {
      return {
        status,
        msg: mensagem,
      };
    } else {
      return {
        status,
        msg: mensagem,
      };
    }
  } catch (error: any) {
    if (error.response?.data?.mensagem) {
      return {
        isError: true,
        msg: error.response.data.mensagem,
      };
    }
    throw new FarmaError(error);
  }
};

function* parseAtribuiPaineisUsuario({ payload }: { payload: any, type: any }) {
  const { userId, paineis } = payload;
  try {
    const { status, msg } = yield call(fetchAtribuiPaineisUsuario, userId, paineis);
    if (status) {
      yield put(atribuiPaineisUsuarioSuccess({ msg }));
    } else {
      yield put(
        painelUserErrorMsg({
          msg
        })
      );
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(painelUserErrorMsg({ msg: mensagem }));
  }
}

export function* watchAtribuiPaineisUsuario() {
  yield takeEvery(ATRIBUI_PAINEIS_USUARIO_INIT, parseAtribuiPaineisUsuario);
}

// ------------------------Desatribuir Painéis ao usuario -------------------------------

const fetchDesatribuiPaineisUsuario = async (userId: string) => {
  try {
    const { status, mensagem } = await desatribuirPaineisUsuario(userId);
    if (status) {
      return {
        status,
        msg: mensagem,
      };
    } else {
      return {
        status,
        msg: mensagem,
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDesatribuiPaineisUsuario({ payload }: { payload: any, type: any }) {
  try {
    // TODO ????
    const { status, msg } = yield call(fetchDesatribuiPaineisUsuario, payload);
    if (status) {
      yield put(desatribuiPaineisUsuarioSuccess({ msg }));
    } else {
      yield put(
        painelUserErrorMsg({
          msg
        })
      );
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(painelUserErrorMsg({ msg: mensagem }));
  }
}

export function* watchDesatribuiPaineisUsuario() {
  yield takeEvery(DESATRIBUI_PAINEIS_USUARIO_INIT, parseDesatribuiPaineisUsuario);
}


// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchAtribuiPaineisUsuario),
    fork(watchDesatribuiPaineisUsuario),
  ]);
}
